module.exports = __webpack_public_path__ + "static/img/product_statisticalTime.081ffc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_statisticalTime.jpg
// module id = P4qc
// module chunks = 0